import styled from 'styled-components'
import {spacing} from '../../../../../theme/spacing'

interface Props {
    showFilter: boolean
}
export const SectionHeader = styled.header<Props>`
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: ${spacing(2)} ${spacing(3)};
    margin: 0;
    border-bottom: ${(props) =>
        props.showFilter ? 'none' : `1px solid ${props.theme.colors.border.lowContrast}`};
    width: 100%;
`
export const SectionTitle = styled.h2`
    font-size: 21px;
    line-height: 28px;
    letter-spacing: 0.42px;
    font-weight: ${(props) => props.theme.font.weight.bold};
    flex-flow: 1;
    flex-shrink: 1;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    padding: 0;
    margin: 0;
`
